export default __webpack_public_path__ + "static/logo-af59be6f7a11520c047506f995d4de18.svg";